module.exports = __webpack_public_path__ + "static/img/ogawa_logo.1bfb917d.png";